/**
 * Cancel a pending object-selection resolution when a later background click takes
 * precedence. Returns whether the click should be ignored because it belongs to
 * the select-box completion guard window.
 */
export function abortPendingSelectionForBackgroundClick(
    withinSelectBoxGuardWindow: boolean,
    abortSelection: () => void,
): boolean {
    if (withinSelectBoxGuardWindow) {
        return true;
    }

    abortSelection();
    return false;
}
